import React, { useEffect, useMemo, useState } from 'react';
import { Card, Select, Space, Typography } from 'antd';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import QaqcPipeWpsCreate from './QaqcPipeWpsCreate';
import type { QaqcPipeWps } from '../../../../types';
import { fetchSqlData } from '../../../../services/api';
import { useGetQaqcPipeWps } from '../../../../hooks/genericHooks';

const QaqcPipeWpsEdit: React.FC = () => {
  const navigate = useNavigate();
  const { state } = useLocation() as { state?: { record?: QaqcPipeWps } };
  const params = useParams();
  const [record, setRecord] = useState<QaqcPipeWps | undefined>(state?.record);
  const { data: wpsResp } = useGetQaqcPipeWps();

  useEffect(() => {
    const load = async () => {
      if (record) return;
      const id = params.id ? Number(params.id) : NaN;
      if (!Number.isFinite(id)) return;
      try {
        const res = await fetchSqlData('qaqc_pipe_wps', 'id', id);
        const row = Array.isArray((res as any)?.data) ? (res as any).data[0] : (Array.isArray(res) ? (res as any)[0] : undefined);
        if (row) setRecord(row as QaqcPipeWps);
      } catch {}
    };
    load();
  }, [params.id]);

  const goBack = () => navigate('/qaqc/piping/tools/wps');

  const wpsOptions = useMemo(() => {
    const rows: QaqcPipeWps[] = (wpsResp?.data as any) || [];
    return rows.map(w => ({ value: w.id, label: `${w.wps_name}`, rec: w }))
      .sort((a,b)=>String(a.label).localeCompare(String(b.label)));
  }, [wpsResp]);

  const missingId = !record && !(params.id && Number.isFinite(Number(params.id)));

  return (
    <>
      {missingId && (
        <Card size="small" title={<Typography.Text strong>Select a WPS to edit</Typography.Text>}>
          <Select
            showSearch
            allowClear
            placeholder="Search WPS"
            style={{ width: 420 }}
            options={wpsOptions}
            optionFilterProp="label"
            filterOption={(input, option) => {
              const label = String(option?.label || '').toLowerCase();
              const tokens = input.trim().toLowerCase().split(/\s+/).filter(Boolean);
              return tokens.every(t => label.includes(t));
            }}
            onChange={(val, opt: any) => {
              const id = Number(val);
              const rec = opt?.rec as QaqcPipeWps | undefined;
              if (Number.isFinite(id)) {
                if (rec) setRecord(rec);
                navigate(`/qaqc/piping/tools/wps/edit/${id}`, { state: { record: rec } });
              }
            }}
          />
        </Card>
      )}
      <QaqcPipeWpsCreate
        mode="edit"
        initialValues={record}
        onSaved={() => {
          goBack();
        }}
        onCancel={goBack}
        onBack={goBack}
      />
    </>
  );
};

export default QaqcPipeWpsEdit;
